import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as dompurify from 'dompurify';
const DOMPurify = (dompurify as any).default || dompurify;

@Pipe({
  name: 'colorCode',
  standalone: true
})
export class ColorCodePipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any): SafeHtml {
    if (!value) return this.sanitizer.bypassSecurityTrustHtml('');

    // Step 1: Special characters escape
    const escapedValue = String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

    // Step 2: Split into parts
    const part1 = escapedValue.slice(0, 4);
    const part2 = escapedValue.slice(4, 7);
    const part3 = escapedValue.slice(7, 9);
    const part4 = escapedValue.slice(9, 12);
    const part5 = escapedValue.slice(12, 16);
    const part6 = escapedValue.slice(16);

    // Step 3: HTML create (no whitespace between spans, or it renders as a visible gap in the code)
    const html = `<span class="text-primary">${part1}</span><span class="text-success">${part2}</span><span class="text-danger">${part3}</span><span class="text-orange">${part4}</span><span class="text-purple">${part5}</span><span class="text-primary">${part6}</span>`;

    // Step 4: Very strict cleaning using DOMPurify
    const sanitized = DOMPurify.sanitize(html, {
      ALLOWED_TAGS: ['span'],           // span only
      ALLOWED_ATTR: ['class'],          // class attribute only
      FORBID_TAGS: ['script', 'style', 'img', 'a', 'iframe'],
      FORBID_ATTR: ['onclick', 'onerror', 'onload', 'style']
    });

    return this.sanitizer.bypassSecurityTrustHtml(sanitized);
  }
}
